
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-mermaid.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-mermaid-demo-mermaid"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-mermaid.zh-CN.md?type=demo')
};